import { useSelector } from 'react-redux';
import isEqual from 'lodash/isEqual';
import { createSelector } from '@reduxjs/toolkit';

export const loggedUSerSelector = (state) => state?.loggedUser?.user;

export const JWTSelector = (state) => state?.loggedUser?.user?.jwt;

export const loggedUserSelector = createSelector(
	(state) => state?.loggedUser?.user,
	(user) => {
		// eslint-disable-next-line no-unused-vars
		const { jwt, ...result } = user || {};
		const lastResult = loggedUserSelector.lastResult();
		if (isEqual(lastResult, result)) return lastResult;
		return result; // return the user without JWT. This is to avoid re-renders. You can get the JWt from the access_token cookie
	},
);

export const userIdSelector = (state) => state?.loggedUser?.user?.id;

export const useLoggedUserSelector = () => useSelector(loggedUserSelector);
